import React, { createContext } from "react";
import { toast } from "react-toastify";
import { Constants } from "../../../libs/Constants";
import { get } from "../../../libs/dbFunctions";

const initialState = {
  employee: null,
};
const EmployeeContext = createContext({
  ...initialState,
  setEmployee: (employee) => {},
  refreshEmployee: () => {},
});

export const EmployeeProvider = ({ children }) => {
  // const [employee, setEmployee] = React.useState(initialState.employee);
  const [state, setState] = React.useState(initialState);
  const refreshEmployee = async (empId) => {
    try {
      let employeeId = empId;
      if (!empId && state && state.employee) {
        employeeId = state.employee.id;
      }
      //fetch user data
      const userDetails = await get(Constants.dbTypes.USER, employeeId);
      setState({ ...state, employee: userDetails });
    } catch (err) {
      toast.error("Unable to load employee data");
    }
  };
  const setEmployee = (employee) => {
    setState({ ...state, employee });
  };
  return (
    <EmployeeContext.Provider
      value={{
        ...state,
        setEmployee,
        refreshEmployee,
      }}
    >
      {children}
    </EmployeeContext.Provider>
  );
};
export default EmployeeContext;
